import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'reactstrap';

const calculateDuration = (eventTime) =>
  moment.duration(
    Math.max(eventTime - Math.floor(Date.now() / 1000), 0),
    'seconds'
  );

const AprilPage = () => {
  const { id } = useParams();
  const data = JSON.parse(atob(id));
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [utr, setUtr] = useState('');
  const [duration, setDuration] = useState(calculateDuration(data?.e));

  const toggle = () => setModal(!modal);

  const timerRef = useRef(0);
  const timerCallback = useCallback(() => {
    setDuration(calculateDuration(data?.e));
  }, [data?.e]);

  useEffect(() => {
    timerRef.current = setInterval(timerCallback, 1000);

    return () => {
      clearInterval(timerRef.current);
    };
  }, [data?.e, timerCallback]);

  const handleSubmit = () => {
    if (utr < 12)
      return alert(
        `Enter UTR ERROR! \nUTR is 12 digits. \nIf you ref no code is less than 12 digits, please fill 0 in the front until 12 digits.`
      );
    navigate('/utr_success');
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(data?.up);
    setTimeout(() => alert('Copy Success!'), 500);
  };

  return (
    <div className='april-page'>
      <nav className='nav'>
        <h5>Pay-In</h5>
        <p>
          {duration.minutes()}: {duration.seconds()}
        </p>
      </nav>
      <p className='amount'>{data?.a}</p>
      <div className='container-sm mt-3' style={{ maxWidth: '544px' }}>
        <div className='border-section'>
          <h5>
            UPI ID: <span>{data?.up}</span>
          </h5>
          <button onClick={handleCopy}>copy</button>
        </div>
        <div className='border-input mt-3'>
          <input
            placeholder='Enter UTR'
            value={utr}
            onChange={(e) => setUtr(e.target.value)}
            maxLength='12'
          />
          <button onClick={handleSubmit}>Submit</button>
        </div>
        <div className='d-flex justify-content-end'>
          <p className='blue-link' onClick={toggle}>
            How To Get UTR?
          </p>
        </div>
        <p className='text-left-red mt-3'>
          Important reminder: After completing the UPI transaction, please
          backfill Ref No./UTR No. : UPI Transaction ID/Freecharge: Transaction
          ID (12digits).
        </p>
        <p className='text-center-black mt-3'>
          Paytm, PhonePe, GPay, BHIM & More
        </p>
        <div className='social-images mt-3'>
          {[
            '/images/logo-1.png',
            '/images/logo-2.png',
            '/images/logo-3.png',
            '/images/logo-4.png',
            '/images/logo-5.jpeg',
            '/images/logo-6.jpeg'
          ].map((image, index) => (
            <img key={index} src={image} alt='google' />
          ))}
        </div>
      </div>
      <Modal
        style={{ gap: '.4rem' }}
        isOpen={modal}
        toggle={toggle}
        backdrop={true}
      >
        <div className='d-flex flex-column gap-1'>
          {[
            '/images/small1.png',
            '/images/small2.png',
            '/images/small3.png',
            '/images/small4.png',
            '/images/small5.png'
          ].map((image, index) => (
            <img key={index} src={image} alt='google' />
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default AprilPage;
